package org.dronda.lib.validation.rules

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import org.dronda.lib.validation.ValidationError


data class GreaterThanMaxLength(val value: String, val max: Int) : ValidationError()
data class LessThanMinLength(val value: String, val min: Int) : ValidationError()

fun minLength(value: String, minLength: Int): Result<String, ValidationError> {
    return if (value.length < minLength) {
        Err(LessThanMinLength(value, minLength))
    } else {
        Ok(value)
    }
}

fun maxLength(value: String, maxLength: Int): Result<String, ValidationError> {
    return if (value.length > maxLength) {
        Err(GreaterThanMaxLength(value, maxLength))
    } else Ok(value)
}